import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function getGroupsByParticipant(userId) {
    try {
        const data = await axios.get(`${REACT_APP_API}/groups/participant/${userId}`)
        return data?.data
    } catch (error) {
        throw new Error(error)
    }
}
